(function () {
  var params = new URLSearchParams(window.location.search);
  var zip = params.get('zip');
  if (!zip) return;

  if (window.history && window.history.replaceState) {
    var cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('zip');
    window.history.replaceState({}, document.title, cleanUrl.toString());
  }

  var nativeValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

  function pressEnter(input) {
    ['keydown', 'keyup'].forEach(function (type) {
      input.dispatchEvent(new KeyboardEvent(type, {
        key: 'Enter', code: 'Enter', keyCode: 13, which: 13, bubbles: true
      }));
    });
  }

  function typeInto(input, text, onDone) {
    input.focus();
    var current = '';
    var i = 0;
    (function typeNext() {
      if (i >= text.length) { onDone(); return; }
      var ch = text[i];
      current += ch;
      nativeValueSetter.call(input, current);
      var opts = { key: ch, bubbles: true };
      input.dispatchEvent(new KeyboardEvent('keydown', opts));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new KeyboardEvent('keyup', opts));
      i++;
      setTimeout(typeNext, 70);
    })();
  }

  var typed = false;
  var attempts = 0;
  var maxAttempts = 40; // ~10s at 250ms

  var poll = setInterval(function () {
    attempts++;
    var input = document.querySelector('.mapboxgl-ctrl-geocoder--input');

    if (input && !typed) {
      typed = true;
      clearInterval(poll);

      typeInto(input, zip, function () {
        var suggestAttempts = 0;
        var suggestPoll = setInterval(function () {
          suggestAttempts++;
          var hasSuggestion = document.querySelector('.mapboxgl-ctrl-geocoder--suggestion');
          if (hasSuggestion || suggestAttempts > 20) {
            clearInterval(suggestPoll);
            pressEnter(input);
          }
        }, 200);
      });
    } else if (attempts > maxAttempts) {
      clearInterval(poll);
    }
  }, 250);
})();
